import classnames from 'classnames'
import PropTypes from 'prop-types'
import { createRef, PureComponent } from 'react'
import { Form, Icon, Message } from 'semantic-ui-react'

import { ImageCrop, SimpleButton } from 'ui'

import Block from 'components/ui/Block'

import styles from './index.css'

const isRequired = (val) => (val.replaceAll(/([^a-z0-9]+)/gi, '').length > 0 ? null : 'Requerido')

const is3Chars = (val) =>
  val.trim().replaceAll(/([^a-z0-9]+)/gi, '').length >= 3 ? null : 'Incluye 3 o más caracteres'

class PlayerForm extends PureComponent {
  addSelectedImage = () =>
    this.setState((prevState) => ({
      croppingImages: (prevState.croppingImages + 1) % 3,
    }))

  el = createRef()

  state = {
    croppingImages: 0,
    fields: {
      avatar: {
        error: null,
        getError: Function.prototype,
        value: null,
      },
      born_at: {
        error: null,
        getError: isRequired,
        value: '',
      },
      first_name: {
        error: null,
        getError: is3Chars,
        value: '',
      },
      gender: {
        error: null,
        getError: isRequired,
        value: '',
      },
      last_name: {
        error: null,
        getError: is3Chars,
        value: '',
      },
      nin: {
        error: null,
        getError: is3Chars,
        value: '',
      },
      number: {
        error: null,
        getError: isRequired,
        value: '',
      },
      picture: {
        error: null,
        getError: Function.prototype,
        value: null,
      },
    },
  }

  onChangeInput = ({ target: { name, value } }) =>
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        [name]: {
          ...fields[name],
          error: null,
          value,
        },
      },
    }))

  onSaveForm = () => {
    const fields = { ...this.state.fields }
    let errors = 0

    Object.keys(fields).forEach((field) => {
      fields[field].error = fields[field].getError(fields[field].value)
      errors += !!fields[field].error
    })

    if (errors) {
      this.setState({ fields }, () => this.el?.current?.querySelector('.field.error input')?.focus())
    } else {
      const data = {}
      Object.keys(fields).forEach((key) => {
        data[key] = fields[key].value
      })
      this.props.onSave(data)
    }
  }

  removeSelectedImage = () =>
    this.setState((prevState) => ({
      croppingImages: Math.max(prevState.croppingImages - 1, 0),
    }))

  renderTournamentCreator() {
    const { fields } = this.state
    return (
      <div>
        <h2>2. Crea tu torneo</h2>
        <p>Configura los datos básicos de tu competición.</p>
        <Form autoComplete="off">
          <div className={styles.formColumns}>
            <div className={styles.avatarColumn}>
              <ImageCrop
                className={styles.avatarCrop}
                cropHeight={200}
                cropWidth={200}
                onCut={(_, value) => {
                  this.onChangeInput({ target: { name: 'tournament_image', value } })
                  this.removeSelectedImage()
                }}
                onDeselect={this.removeSelectedImage}
                onRemove={() =>
                  this.onChangeInput({
                    target: {
                      name: 'tournament_image',
                      value: null,
                    },
                  })
                }
                onSelect={this.addSelectedImage}
              >
                <div>
                  <Icon name="trophy" size="big" />
                  <br />
                  Agrega una imagen o
                  <br />
                  avatar para tu torneo
                </div>
              </ImageCrop>
            </div>
            <div>
              <Form.Group widths="equal">
                <Form.Input
                  error={fields.tournament_name.error}
                  label="Nombre"
                  name="tournament_name"
                  onChange={this.onChangeInput}
                  required
                  size="mini"
                  value={fields.tournament_name.value}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Input
                  error={fields.tournament_nickname.error}
                  label="Nickname"
                  maxLength={10}
                  name="tournament_nickname"
                  onChange={this.onChangeInput}
                  required
                  size="mini"
                  value={fields.tournament_nickname.value}
                />
              </Form.Group>
            </div>
          </div>
          <Form.Group widths="equal">
            <Form.Input
              error={fields.tournament_season.error}
              label="Temporada"
              maxLength={15}
              name="tournament_season"
              onChange={this.onChangeInput}
              required
              size="mini"
              value={fields.tournament_season.value}
            />
          </Form.Group>
        </Form>
      </div>
    )
  }

  render() {
    const { className, onCancel, saving } = this.props
    const { croppingImages, fields } = this.state

    return (
      <Block className={classnames(styles.container, className)}>
        <div className={styles.containerColumns} ref={this.el}>
          <Form autoComplete="off">
            <div className={styles.formColumns}>
              <div className={styles.avatarColumn}>
                <ImageCrop
                  className={styles.avatarCrop}
                  cropHeight={200}
                  cropWidth={200}
                  onCut={(_, value) => {
                    this.onChangeInput({ target: { name: 'avatar', value } })
                    this.removeSelectedImage()
                  }}
                  onDeselect={this.removeSelectedImage}
                  onRemove={() =>
                    this.onChangeInput({
                      target: {
                        name: 'avatar',
                        value: null,
                      },
                    })
                  }
                  onSelect={this.addSelectedImage}
                >
                  <div>
                    <Icon name="user outline" size="big" />
                    <br />
                    <br />
                    Agrega un avatar para el jugador
                  </div>
                </ImageCrop>
              </div>
              <div>
                <Form.Group widths="equal">
                  <Form.Input
                    error={fields.first_name.error}
                    label="Nombres"
                    name="first_name"
                    onChange={this.onChangeInput}
                    required
                    size="mini"
                    value={fields.first_name.value}
                  />
                </Form.Group>
                <Form.Group widths="equal">
                  <Form.Input
                    error={fields.last_name.error}
                    label="Apellidos"
                    name="last_name"
                    onChange={this.onChangeInput}
                    required
                    size="mini"
                    value={fields.last_name.value}
                  />
                </Form.Group>
              </div>
            </div>
          </Form>
        </div>
        <div className={styles.actionBar}>
          {croppingImages ? (
            <Message>
              <Icon name="info" />
              Termina de modificar la imagen actual para continuar.
            </Message>
          ) : (
            <>
              {!saving && <SimpleButton onClick={onCancel} secondary value="Cancelar" />}
              <SimpleButton
                disabled={saving}
                onClick={this.onSaveForm}
                primary
                value={saving ? 'Actualizando...' : 'Actualizar'}
              />
            </>
          )}
        </div>
      </Block>
    )
  }
}

PlayerForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  player: PropTypes.shape({}).isRequired,

  className: PropTypes.string,
  saving: PropTypes.bool,
}

PlayerForm.defaultProps = {
  className: '',
  saving: false,
}

export default PlayerForm
